export const config = {
  title: 'MGP Construction LLC',
  meta: {
    description:
      'MGP Construction LLC offers comprehensive construction and renovation services in Elizabeth, NJ, specializing in home transformations including kitchens, baths, basements, and more.',
    keywords: [
      'Construction Services',
      'Home Remodeling',
      'Kitchen Renovation',
      'Bathroom Remodeling',
      'Basement Finishing',
      'MGP Construction LLC',
      'Elizabeth NJ Construction',
      'New Jersey Home Improvement',
      'MyBizSolutions LLC',
      'BizSolutions LLC'
    ],
    author: 'MGP Construction LLC',
    canonicalUrl: 'https://www.mgpconstructionservices.com/',
  },
  sections: {
    header: {
      businessName: 'MGP Construction LLC',
    },
    sectionB: {
      heroTitle: 'MGP Construction LLC',
      heroSubtitle: 'Transforming Homes with Quality Construction & Renovation',
      learnAboutText: 'Learn About Our Services',
      phoneNumber: '9735639296',
      phoneLabel: '(973) 563-9296',
      heroBackgroundImage:
        'https://media.istockphoto.com/id/1345384816/photo/construction-industry-and-engineering-in-post-recession-period.jpg?s=612x612&w=0&k=20&c=3sK6hLkePixyVhbjrSDKATOx9cVnbor2d2qASBkUucM=',
      cardData: [
        {
          title: 'Experienced Professionals',
          description:
            'Over 15 years of experience delivering exceptional construction and renovation services.',
        },
        {
          title: 'Comprehensive Services',
          description:
            'From kitchen remodels to basement finishing, we handle all aspects of your project.',
        },
        {
          title: 'Quality Craftsmanship',
          description:
            'Committed to excellence and attention to detail in every project we undertake.',
        },
      ],
      description:
        'At MGP Construction LLC, we specialize in transforming homes with our comprehensive construction and renovation services. Our expertise includes kitchen and bathroom remodeling, basement finishing, and more, ensuring top-notch quality and customer satisfaction.',
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        'Explore our wide range of construction and renovation services designed to bring your vision to life.',
      cards: [
        {
          title: 'Kitchen Remodeling',
          description:
            'Creating modern and functional kitchen spaces tailored to your needs.',
          imageSrc: 'https://static.wixstatic.com/media/2ea1cf_8f3c4d55fbb941e7b394988f598c56e9~mv2.jpg/v1/fill/w_308,h_332,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/d7418a7e-8433-4f1a-b127-ac2fa6f3fda3_JPG.jpg',
          imageAlt: 'Kitchen Remodeling',
        },
        {
          title: 'Bathroom Renovation',
          description:
            'Transforming bathrooms into luxurious and comfortable spaces.',
          imageSrc: 'https://static.wixstatic.com/media/2ea1cf_4114d33b12b44de3acf9c10825c35037~mv2.jpg/v1/fill/w_308,h_332,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/e82b5971-f349-41f4-9a23-6040101ca88a_JPG.jpg',
          imageAlt: 'Bathroom Renovation',
        },
        {
          title: 'Basement Finishing',
          description:
            'Converting basements into functional living areas.',
          imageSrc: 'https://static.wixstatic.com/media/2ea1cf_76ca00f72e9e492d83c70c48c1f7d540~mv2.jpg/v1/fill/w_312,h_332,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/c7394587-08e2-41e1-8809-412d4f40ecc7_JPG.jpg',
          imageAlt: 'Basement Finishing',
        },
      ],
      otherServicesTitle: 'Additional Services',
      otherServicesList: [
        'Tile Installation',
        'Decks Installation',
        'Fences',
        'Trim',
        'Framing Construction',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://static.wixstatic.com/media/2ea1cf_ea8e351e2eb345a392fc6c6cafe57134~mv2.jpg/v1/fill/w_270,h_360,al_c,q_80,enc_avif,quality_auto/2ea1cf_ea8e351e2eb345a392fc6c6cafe57134~mv2.jpg',
        alt: 'MGP Construction LLC Team',
      },
      aboutText: [
        'With over 15 years of experience, MGP Construction LLC has been a trusted name in the construction industry, delivering exceptional craftsmanship and attention to detail.',
        'Our mission is to transform homes with unmatched reliability and innovation, ensuring every project reflects excellence and customer satisfaction.',
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: 'MGP Construction LLC Logo',
      businessName: 'MGP Construction LLC',
      contact: {
        phone: '9735639296',
        phoneLabel: '(973) 563-9296',
        email: 'marcio.mgpconstruction@gmail.com',
        website: 'https://www.mgpconstructionservices.com/',
        address: '409 Marshall St, Elizabeth, NJ 07206',
      },
      socialMedia: {
        facebook: 'https://www.facebook.com/profile.php?id=61570122924362',
        instagram: 'https://www.instagram.com/mgpconstructions/',
        linkedin: null,
        twitter: null,
        youtube: null,
      },
    },
    sectionF: {
      address: '409 Marshall St, Elizabeth, NJ 07206',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3023.123456789012!2d-74.1234567!3d40.6567890!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c2f1234567890%3A0xabcdef1234567890!2s409%20Marshall%20St%2C%20Elizabeth%2C%20NJ%2007206!5e0!3m2!1sen!2sus!4v1710407450828!5m2!1sen!2sus',
    },
  },
};

export default config;
